export default "__VITE_ASSET__C1OfvhUo__$_?react__"